<template>
    <div class="w-100">
        <div class="filter-header">
            <div class="fs-14 font-weight-bold ml-4">Filters (<span style="color:#ffba00 !important;">{{totalFilters}}</span>)</div>
            <div class="pointer">
                <span>
                    <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/ArrowBgBlue.svg" style="width: 35px;" alt="arrow">
                </span>
                <span >
                    <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/ResetBgBlue.svg" alt="reset">
                </span>
                <span>
                    <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/CloseBgBlue.svg" alt="close">
                </span>
            </div>
        </div>
        <div class="w-100">
            <div class="row w-100 m-0">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class=" mt-4">
                        <span class="fs-13 fw-600 text-filter-label">
                            Ticket ID
                        </span>
                        <multiselect :limit="1" :limit-text="limitTicketId" track-by="ticket_id"
                            class="diginew-multiselect diginew-multiselect-underline  filter-multiple mt-2" id="ajax"
                            placeholder="Select Ticket Number" label="ticket_number"
                            :options="ticket_number_options" v-model="ticket_number"
                            :multiple="true" :searchable="true" :internal-search="false"
                            :clear-on-select="true" :close-on-select="false" :options-limit="40"
                            :max-height="200" :show-no-results="true" :hide-selected="false"
                            :loading="ticket_loading" @search-change="getAllTicketAPI"
                            @remove="removeTicket" :blockKeys="['Delete']"
                        >
                        <template slot="tag" slot-scope="{ option }">
                            <span class="custom__tag">
                            <span class="filterSelectedName">{{ option.ticket_number }}</span>
                                <span class="custom__remove pointer" @click="removeTicket(option)">
                                <i class="icon icon-close fs-16 text-brownish-grey"></i>
                                </span>
                            </span>
                        </template>
                        <template slot="afterList">
                            <div v-observe-visibility="reachedEndOfTickets" />
                        </template>
                        <template slot="noResult">
                            <div v-if="ticket_number_options.length">
                                <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                            <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                        </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class=" mt-4">
                        <span class="fs-13 fw-600 text-filter-label">
                            Creation Date
                        </span>
                        <div class="mt-2 d-flex align-items-center">
                            <date-picker
                                v-model="temp_created_date"
                                name="actiondate"
                                class="filterdate filter-disable filter-date-underline policy-date-popup mr-1 w-100"
                                format="MM/DD/YYYY"
                                type="date"
                                onkeypress="return event.charCode >= 47 && event.charCode <= 57"
                                lang="en"
                                :clearable="false"
                                :editable="false"
                                confirm
                                range
                                confirm-text="APPLY"
                                @change="updatecreationDate()"
                            ></date-picker>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class=" company_filter mt-4">
                        <div class="d-flex align-items-center">
                        <span class="fs-13 fw-600 text-filter-label" style="white-space:nowrap">
                            Assigned To
                        </span>
                        </div>
                        <multiselect label="name"
                            class="diginew-multiselect diginew-multiselect-underline  filter-multiple mt-2" id="ajax"
                            placeholder="Search & Select Assigned Person" track-by="id"
                            :options="assign_options" v-model="assignedCustomer"
                            :multiple="true" :searchable="true" :internal-search="false"
                            :clear-on-select="true" :close-on-select="false" :options-limit="40"
                            :max-height="200" :show-no-results="true" :hide-selected="false"
                            @remove="removeAssignTo" :blockKeys="['Delete']" :loading="assign_loading" @search-change="getAllAssignTo"
                            :limit="1" :limit-text="limitAssignedTo"
                        >
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option.name }}</span>
                                    <span class="custom__remove pointer" @click="removeAssignTo(option)">
                                    <i class="icon icon-close fs-16 text-brownish-grey"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfAssigned" />
                            </template>
                            <template slot="noResult">
                                <div v-if="assign_options.length">
                                    <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                                <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class=" mt-4">
                        <span class="fs-13 fw-600 text-filter-label" style="white-space:nowrap">
                            Ticket Status
                        </span>
                        <multiselect
                            class="diginew-multiselect diginew-multiselect-underline  filter-multiple mt-2" id="ajax"
                            placeholder="Select Status" :limit="1" :limit-text="limitStatus"
                            :options="pending_options" v-model="pending"
                            :multiple="true" :searchable="true" :internal-search="true"
                            :clear-on-select="true" :close-on-select="false" :options-limit="40"
                            :max-height="200" :show-no-results="true" :hide-selected="false" :blockKeys="['Delete']"
                        >
                        <template slot="tag" slot-scope="{ option }">
                            <span v-if="option.ticket_status" class="custom__tag">
                                <span class="filterSelectedName">{{ option.ticket_status }}</span>
                                <span class="custom__remove pointer" @click="removeStatus(option)">
                                <i class="icon icon-close fs-16 text-white"></i>
                                </span>
                            </span>
                            <span v-else class="custom__tag">
                                <span class="filterSelectedName">{{ option }}</span>
                                <span class="custom__remove pointer" @click="removeStatus(option)">
                                <i class="icon icon-close fs-16 text-brownish-grey"></i>
                                </span>
                            </span>

                        </template>
                        <template slot="noResult">
                            <div class="text-secondary text-center fw-600">No Results Found</div>
                        </template>
                        </multiselect>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
import ticket from '../mixins/ticket.js';
import crm from '../mixins/crm.js';
import scm from '../mixins/scm.js';
import { EventBus } from '../eventBus/nav-bar-event.js';
import debounce from 'lodash/debounce';
export default{
    mixins: [ticket, crm, scm],
    data(){
        return{
            // fields
            ticket_number: [],
            temp_created_date: [],
            created_date: [],
            assignedCustomer: [],
            pending: [],
            pending_options:['Open','Inprogress','Fixed','Closed','Reopen'],
            // ticket lazy loading
            ticket_number_options:[],
            temp_ticket_number_options:[],
            ticket_loading: false,
            ticket_count: 0,
            ticket_scrollable: false,
            tickets_visible: false,
            totalFilters: 0,
            // Assigned to lazy loading
            assign_visible: false,
            assign_scrollable: false,
            assign_loading: false,
            assign_count: 0,
            temp_assign_options: [],
            assign_options: [],
        }
    },
    components: {
        VueTagsInput
    },
    methods: {
        limitTicketId(count){
            return `+ ${count} more`
        },
        limitStatus(count){
            return `+ ${count} more`
        },
        removeTicketType(option){
            this.ticket_type.forEach((el,index)=>{
                if(el._id == option._id){
                    this.ticket_type.splice(index,1)
                }
            })
        },
        removeAssignTo(option){
            this.assignedCustomer.forEach((el,index)=>{
                if(el.id == option.id){
                    this.assignedCustomer.splice(index,1)
                }
            })
        },
        updatecreationDate(){
            if(this.temp_created_date){
                let value = this.convertFilter(this.temp_created_date[0])
                let value1 = this.convertFilter(this.temp_created_date[1])
                let newValue = [value,value1]
                this.created_date = newValue
            }else{
                this.created_date = []
                this.temp_created_date = []
            }
        },
        async getAllTicketAPIDebouncer(search_key){
            this.ticket_loading = true
            try {
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key,
                }
                let res = await this.getAllTickets(params)
                // let uniqueArray = res.response.all_tickets.filter((value, index_dd) => {
                //     const _value = JSON.stringify(value);
                //     return index_dd === res.response.all_tickets.findIndex(obj => {
                //         return JSON.stringify(obj) === _value;
                //     });
                // });
                // this.ticket_number_options = uniqueArray
                this.ticket_number_options = res.response.all_tickets
                this.ticket_count = this.temp_products.length
                this.ticket_loading = false
                this.ticket_scrollable = false
            } catch (reason) {
                console.log(reason)
                this.ticket_loading = false
            }
        },
        async getAllAssignToDebouncer(search_key){
            try {
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getUserForTicketsFilter(params)
                // let uniqueArray = res.response.users.filter((value, index_dd) => {
                //     const _value = JSON.stringify(value);
                //     return index_dd === res.response.users.findIndex(obj => {
                //         return JSON.stringify(obj) === _value;
                //     });
                // });
                // this.assign_options = uniqueArray
                this.assign_options = res.response.users
                this.assign_count = this.temp_assign_options.length
                this.assign_loading = false
                this.assign_scrollable = false
            } catch (reason) {

            }
        },
        async reachedEndOfTickets(reached){
            this.tickets_visible = reached
            if (reached) {
                if (this.ticket_scrollable == false) {
                    this.ticket_loading = true
                    let params ={
                        skip:this.ticket_count,
                        limit:10,
                        search_key:'',
                        is_mobile:false,
                        is_service_ticket:false,
                        sort_key: "ticket_number",
                    }
                    let response = await this.getAllTickets(params)
                    this.temp_ticket_number_options = response.response.all_tickets.length;
                    if (response.response.skip == this.ticket_count) {
                        if (this.temp_ticket_number_options > 0) {
                            let tempFiles = response.response.all_tickets;
                            tempFiles.forEach(el => {
                                this.ticket_number_options.push(el);
                            });
                            this.ticket_count += response.response.all_tickets.length;
                            this.ticket_loading = false
                        } else {
                            this.ticket_scrollable = true
                            this.ticket_loading = false
                        }
                    }
                    this.ticket_loading = false
                }
            }
        },
        async reachedEndOfAssigned(reached){
            this.assign_visible = reached
            if (reached) {
                if (this.assign_scrollable == false) {
                    this.assign_loading = true
                    let params ={
                        skip:this.assign_count,
                        limit:10,
                        search_key:''
                    }
                    let response = await this.getUserForTicketsFilter(params)
                    this.temp_assign_options = response.response.users.length;
                    if (response.response.skip == this.assign_count) {
                        if (this.temp_assign_options > 0) {
                            let tempFiles = response.response.users;
                            tempFiles.forEach(el => {
                                this.assign_options.push(el);
                            });
                            this.assign_count += response.response.users.length;
                            this.assign_loading = false
                        } else {
                            this.assign_scrollable = true
                            this.assign_loading = false
                        }
                    }
                    this.assign_loading = false
                }
            }
        },
    },
    computed:{
        getAllTicketAPI(){
            return debounce(this.getAllTicketAPIDebouncer, 500)
        },
        getAllAssignTo(){
            return debounce(this.getAllAssignToDebouncer, 500)
        }, 
    },
    mounted(){
        // this.ticket_number = this.showfilterData.ticket_number
        // this.created_date = this.showfilterData.created_date
        // if(this.created_date.length){
        //     this.temp_created_date = [];
        //     this.temp_created_date[0] = this.dateFormat(this.created_date[0],'yyyy-MM-dd')
        //     this.temp_created_date[1] = this.dateFormat(this.created_date[1],'yyyy-MM-dd')
        // }
        // this.assignedCustomer = this.showfilterData.assigned_to
        // this.templates = this.showfilterData.created_templates
        // this.entered_tag = this.showfilterData.created_tags
        // this.pending = this.showfilterData.status
    },
    created(){

    }
}
</script>

<style scoped>
    .inputFilter {
        font-size: 14px;
        padding: 10px;
        display: block;
        height: 44px;
        width: 100%;
        border: none;
        color: #808495 !important;
        background-color: #ffffff;
        border-radius: 8px;
        font-weight: 500;
        margin-top: 10px;
        font-family: 'Poppins', sans-serif !important;
    }
    .inputFilter::placeholder{
        color: #808495;
        font-weight: normal !important;
    }
    .mx-datepicker.actiondate .mx-input {
        display: inline-block;
        width: 100%;
        height: 40px !important;
        padding: 6px 6px !important;
        font-size: 14px;
        line-height: 1.4;
        color: #ffffff;
        background-color: #4d8ddd !important;
        border: 1px solid #0475f3 !important;
        border-radius: 8px !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        text-align: left !important;
    }
    .saveAs{
        position: absolute;
        top: 35px;
        background-color: #ffffff;
        padding: 10px;
        border-radius: 5px;
        font-family: 'Poppins', sans-serif !important;
    }
    ._close{
        float: right;
    }
    .date-pop .mx-datepicker-popup{
        position: relative;
        top: 0px;
    }
    .scm-filters {
        position: fixed;
        top: 50px;
        left: 0;
        width: 100%;
        background: #e6ecff !important;
        height: 100%;
        border-radius: 0 !important;
        overflow: scroll !important;
        padding-bottom: 80px;
    }

    .clear-icon{
        position: absolute;
        top: 13px;
        left: 337px;
        background-color: #fff;
    }
</style>